document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(e) {
        if (e.target.matches('.upsell-add-to-cart')) {
            e.preventDefault();
            const button = e.target;
            const variantId = button.getAttribute('data-product-id');
            
            if (!variantId) return;

            const originalText = button.innerText;
            button.innerText = 'Adding...';
            button.disabled = true;

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items: [
                        {
                            id: variantId,
                            quantity: 1
                        }
                    ]
                })
            })
            .then(response => response.json())
            .then(data => {
                // Trigger Halo theme native cart update
                fetch(window.Shopify.routes.root + 'cart.js')
                .then(res => res.json())
                .then(cart => {
                    if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
                        window.sharedFunctions.updateSidebarCart(cart);
                    } else if (typeof halo !== 'undefined' && halo.updateSidebarCart) {
                        halo.updateSidebarCart(cart);
                    } else {
                        // Fallback
                        window.location.reload();
                    }
                });
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                button.innerText = originalText;
                button.disabled = false;
            });
        }
    });
});
